export const css = {
    root: '_1SBrPI2z',
    nav_drawer: 'DfZ5d2VB',
    title: '_4lwMVLhR',
    ' _key': 'table-of-contents/drawer'
};
export default css;
